import type { BeforeInstallPromptEvent } from '@/types';

let deferredInstallPrompt: BeforeInstallPromptEvent | null = null;

const captureInstallPrompt = (event: Event) => {
  event.preventDefault();
  deferredInstallPrompt = event as BeforeInstallPromptEvent;
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', captureInstallPrompt);
}

export const getDeferredInstallPrompt = (): BeforeInstallPromptEvent | null =>
  deferredInstallPrompt;

export const subscribeInstallPrompt = (
  listener: (_prompt: BeforeInstallPromptEvent | null) => void,
): (() => void) => {
  const handler = (event: Event) => {
    captureInstallPrompt(event);
    listener(deferredInstallPrompt);
  };

  window.addEventListener('beforeinstallprompt', handler);

  if (deferredInstallPrompt) {
    listener(deferredInstallPrompt);
  }

  return () => {
    window.removeEventListener('beforeinstallprompt', handler);
  };
};

export const clearDeferredInstallPrompt = () => {
  deferredInstallPrompt = null;
};
